module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAJUlEQVQ4T2NgGBSAR6bnPzr+c1EMBZ8TVMPAowaMGjDIDBjaAABNfks5w1lYDgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/TD.png
// module id = 1275
// module chunks = 0